var map = {
	"./de-DE/btn_vote.png": "24d3",
	"./en-GB/btn_vote.png": "1815",
	"./en-US/btn_vote.png": "4242",
	"./es-ES/btn_vote.png": "dc64",
	"./es-MX/btn_vote.png": "f24a",
	"./fr-CA/btn_vote.png": "a337",
	"./fr-FR/btn_vote.png": "1d38",
	"./it-IT/btn_vote.png": "ba3d",
	"./ja-JP/btn_vote.png": "ce29",
	"./pt-BR/btn_vote.png": "a65e",
	"./zh-TW/btn_vote.png": "2caf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b8d";